import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import { useRouter } from "next/router";
import React, { FC } from "react";

import { experts } from "./constants";
import styles from "./styles.module.scss";

const Expertise: FC = () => {
  const router = useRouter();

  return (
    <>
      <Content
        containerClassName={styles.topContainer}
        contentClassName={styles.top}
      >
        <Label variant="h2-centered" color="primary">
          Expertise at your fingertips
        </Label>
      </Content>
      <Content containerClassName={styles.middle}>
        <div className={styles.experts}>
          {experts.map(({ Icon, title, description }) => (
            <div className={styles.expert}>
              <Icon className={styles.icon} />
              <Label variant="h5-centered" color="supplemental">
                {title}
              </Label>
              <Label variant="body-centered" color="supplemental">
                {description}
              </Label>
            </div>
          ))}
        </div>
      </Content>
      <Content contentClassName={styles.bottom}>
        <div>
          <Button variant="accent" onClick={() => router.push("/start")}>
            Get your estimate
          </Button>
        </div>
      </Content>
    </>
  );
};

export default Expertise;
